import { DeckLeglaity, LegalityChecker } from '../deckLegality'
import { ERRORS } from '../legality.const'

const CheckLegality: LegalityChecker = (deck: DeckLeglaity) => {
  const combineDeck = [...deck.commanders, ...deck.mainboard, ...deck.sideboard]

  for (const card of combineDeck) {
    deck.checkCardLegality(card)
    deck.checkCardQuantity(card, 4)
  }

  if (deck.sideboardSize > 15) deck.addError(ERRORS.SIDEBOARD_SIZE)
  if (deck.deckSize < 60) deck.addError(ERRORS.DECK_SIZE)
}

export default CheckLegality
